<template>
  <div class="start-your-selection no-step">
    <h4 class="guide-header">Where do you want to start your selection?</h4>
    <div class="guide-content">
      <div class="form-group form-radio">
        <div class="custom-control custom-radio">
          <input
            type="radio"
            class="custom-control-input"
            value="selectFamily"
            id="family-component"
            name="family-component"
            v-model="selectedTag"
          />
          <label class="custom-control-label" for="family-component">
            Family or component
          </label>
        </div>
      </div>
    </div>
    <div class="btns-container row">
      <div class="col">
        <div class="btn btn-outline-secondary" @click="prev">
          Previous
        </div>
      </div>
      <div class="col">
        <div class="btn btn-secondary" @click="next">
          Next
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "StartYourSelection",
  props: ["tagFamilies"],
  data() {
    return {
      selectedTag: "selectFamily"
    };
  },
  methods: {
    prev() {
      this.$emit("prev", "howCanIHelp");
    },
    next() {
      this.$emit("to", this.selectedTag);
    }
  }
};
</script>
<style lang="scss" scoped>
.guide-content .custom-control {
  padding: 0.15rem 0 0.15rem 1.8rem !important;
}
</style>
